import React, { useState } from "react";
import Chip from "@mui/material/Chip";
import { useNavigate } from "react-router-dom";
import {useSelector} from "react-redux";

const useSales = () => {

    let navigate = useNavigate();

    const authState = useSelector((state) => state.authReducer);
    const roleId = authState.roleId;

    const actions = {
        add: () => authState.roleId !== 1 && navigate("/ventas/nueva-venta"),
        edit: false,
        delete: false,
    };

    const renderStatusChip = (status) => {
        switch (status) {
            case 'pending':
                return <Chip size="small" color="warning" label="Pendiente"
                             variant="outlined"/>;
            case 'in_transit':
                return <Chip size="small" color="secondary" label="Preparando"
                             variant="outlined"/>;
            case 'paid':
                return <Chip size="small" color="success" label="Pagado"
                             variant="outlined"/>;
        }
    };

    return {
        actions,
        renderStatusChip,
        roleId
    }
};

export default useSales;
